export type FieldValue = string | boolean;
export type Validator = (value: FieldValue) => string | undefined;

export function isEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value.trim());
}

export const required =
  (label: string): Validator =>
  (value) =>
    typeof value === 'string' && value.trim() ? undefined : `${label} is required.`;

export const email =
  (label = 'Email'): Validator =>
  (value) => {
    const v = String(value ?? '').trim();
    if (!v) return `${label} is required.`;
    return isEmail(v) ? undefined : 'Enter a valid email address, for example name@company.com.';
  };

export const consent: Validator = (value) =>
  value === true ? undefined : 'Please confirm you have read the privacy notice.';

export const minLength =
  (label: string, min: number): Validator =>
  (value) => {
    const v = String(value ?? '').trim();
    if (!v) return `${label} is required.`;
    return v.length >= min ? undefined : `${label} should be at least ${min} characters.`;
  };

const CV_EXTENSIONS = ['pdf', 'doc', 'docx'];
const CV_MAX_BYTES = 5 * 1024 * 1024;

export function validateCvFile(file: File): string | undefined {
  const ext = file.name.split('.').pop()?.toLowerCase() ?? '';
  if (!CV_EXTENSIONS.includes(ext)) return 'Upload a PDF or Word document (.pdf, .doc, .docx).';
  if (file.size > CV_MAX_BYTES) return 'File is larger than 5 MB. Please upload a smaller file.';
  return undefined;
}
